<template>
    <div>
        <b-container>
            <b-row align-h="center">
                <b-col cols="10">
                    <b-card-group deck>
                        <b-card header="Import Bulk Data" header-tag="header">
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="12">
                                        <div>
                                            <input
                                                type="button"
                                                class="btn btn-primary"
                                                value="Import Project Data"
                                                @click.prevent="launchFileData('import')"
                                            />

                                            <input
                                                type="button"
                                                class="btn btn-primary"
                                                value="Import Companies"
                                                @click.prevent="launchClients"
                                            />

                                            <input
                                                type="button"
                                                class="btn btn-primary"
                                                value="Import Contacts"
                                                @click.prevent="launchContacts"
                                            />

<!--                                            <input-->
<!--                                                type="button"-->
<!--                                                class="btn btn-primary"-->
<!--                                                value="Re-Import Project Data"-->
<!--                                                @click.prevent="launchFileData('re-import')"-->
<!--                                            />-->
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
        <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
    </div>
</template>

<script>
import FlatfileImporter from "@flatfile/adapter";
import config from "../../flatfile-env.js";
import axios from 'axios';
import Swal from 'sweetalert2';
import * as parser from "parse-address";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {round} from "lodash/math";

export default {
    name: "data-import",
    props: ['user', 'marketing_status', 'sale_status', 'client_profile', 'contract_type',
        'lead_from', 'esstimator_acc_manager_take_off_person', 'office', 'product_service',
        'company_types', 'project_custom_fields', 'project_custom_field_options', 'team_users','team_custom_project_ids',
        'company_custom_fields', 'company_custom_field_options', 'contact_custom_fields', 'contact_custom_field_options', 'company_status',
        'project_sales_behaviors', 'contact_sales_behaviors', 'contact_types', 'has_vista_access','has_foundation_access', 'has_spectrum_access',
        'checkVistaContactFieldMapping', 'recordDetailCustomFields', 'recordDetailCustomFieldOptions'
    ],
    data() {
        if (this.has_vista_access) {
            config.contactsConfig.fields.push(  {
                    key: "link_to_vista",
                    label: "Link to Vista",
                    type: "select",
                    options:[
                        {value: "yes", label: "Yes"},
                        {value: "no", label: "No"}
                    ]
                },
                {
                    key: "vista_customer_no",
                    label: "Vista Customer Number"
                });
            config.fileDataConfig.fields.push( {
                    key: "link_to_vista",
                    label: "Link to Vista",
                    type: "select",
                    options:[
                        {value: "yes", label: "Yes"},
                        {value: "no", label: "No"}
                    ]
                },
                {
                    key: "vista_project_no",
                    label: "Vista Job Number"
                },
                {
                    key: "vista_customer_no",
                    label: "Vista Customer Number"
                });


            let vistaFields = [
                {
                    key: "link_to_vista",
                    label: "Link to Vista",
                    type: "select",
                    options:[
                        {value: "yes", label: "Yes"},
                        {value: "no", label: "No"}
                    ]
                },
                {
                    key: "vista_customer_no",
                    label: "Vista Customer Number"
                }
            ];

            config.clientsConfig.fields.splice(15, 0, ...vistaFields);
            // config.clientsConfig.fields.push(  );
        }
        if (this.has_foundation_access) {
            config.contactsConfig.fields.push(  {
                    key: "link_to_foundation",
                    label: "Link to Foundation",
                    type: "select",
                    options:[
                        {value: "yes", label: "Yes"},
                        {value: "no", label: "No"}
                    ]
                },
                {
                    key: "foundation_customer_contact_no",
                    label: "Foundation Customer Number"
                });
            config.fileDataConfig.fields.push( {
                    key: "link_to_foundation",
                    label: "Link to foundation",
                    type: "select",
                    options:[
                        {value: "yes", label: "Yes"},
                        {value: "no", label: "No"}
                    ]
                },
                {
                    key: "foundation_project_no",
                    label: "Foundation Job Number"
                },
                {
                    key: "foundation_customer_contact_no",
                    label: "Foundation Customer Number"
                })
        }
        if (this.has_spectrum_access) {
            config.contactsConfig.fields.push(  {
                    key: "link_to_spectrum",
                    label: "Link to Spectrum",
                    type: "select",
                    options:[
                        {value: "yes", label: "Yes"},
                        {value: "no", label: "No"}
                    ]
                },
                {
                    key: "spectrum_customer_no",
                    label: "Spectrum Customer Number"
                });
            config.fileDataConfig.fields.push( {
                    key: "link_to_spectrum",
                    label: "Link to Spectrum",
                    type: "select",
                    options:[
                        {value: "yes", label: "Yes"},
                        {value: "no", label: "No"}
                    ]
                },
                {
                    key: "spectrum_project_no",
                    label: "Spectrum Job Number"
                },
                {
                    key: "spectrum_customer_no",
                    label: "Spectrum Customer Number"
                })
        }
        return {
            results: "Your raw output will appear here.",
            customProjectIdRegExp: '',
            fullPage: true,
            isLoading: false,
            currentChunkIndex: 0,
            status: [
                {
                    id: "pending", value: "Pending"
                },
                {
                    id: "won", value: "Won"
                },
                {
                    id: "lost", value: "Lost"
                }
            ],
            batch_id: 1,
            data_import_id: null,
            project_sales_behaviors_name: [],
            contact_sales_behaviors_name: [],
            importerFileData: new FlatfileImporter(
                config.license,
                this.$root.currentTeam.custom_project_id_check ? config.fileDataConfig : { ...config.fileDataConfig, fields: config.fileDataConfig.fields.slice(1) }
            ),
            importerClients: new FlatfileImporter(
                config.license,
                config.clientsConfig
            ),
            importerContacts: new FlatfileImporter(
                config.license,
                config.contactsConfig
            ),
            fileDataCustomDateFields: [],
            projectDropdownsIndex: 0
        };
    },
    components: {
        Loading
    },
    mounted() {
        this.projectDropdownsIndex = this.$root.currentTeam.custom_project_id_check ? 1 : 0;
        this.customProjectIdRegExp = this.getCustomProjectIdRegEx();

        const status = this.status.map(statusObj => {
            return ({
                value: statusObj.id,
                label: statusObj.value.trim()
            })
        });

        const sale_status = this.sale_status.map(salesObj => {
            return ({
                value: salesObj.id,
                label: salesObj.code.trim()
            })
        });

        const marketing_status = this.marketing_status.map(marketingObj => {
            return ({
                value: marketingObj.id,
                label: marketingObj.code.trim()
            })
        });

        const client_profile = this.client_profile.map(clientObj => {
            return ({
                value: clientObj.id,
                label: clientObj.full_description.trim()
            })
        });

        const contract_type = this.contract_type.map(contractObj => {
            return ({
                value: contractObj.id,
                label: contractObj.full_description.trim()
            })
        });

        const lead_from = this.lead_from.map(leadFromObj => {
            return ({
                value: leadFromObj.id,
                label: leadFromObj.full_description.trim()
            })
        });

        const esstimator_acc_manager_take_off_person = this.esstimator_acc_manager_take_off_person.map(esstimaterAccountManagerTakeOffPersonObj => {
            return ({
                value: esstimaterAccountManagerTakeOffPersonObj.id,
                label: esstimaterAccountManagerTakeOffPersonObj.name.trim()
            })
        });

        const office = this.office.map(officeObj => {
            return ({
                value: officeObj.id,
                label: officeObj.full_description.trim()
            })
        });

        const product_service = this.product_service.map(productServicesObj => {
            return ({
                value: productServicesObj.id,
                label: productServicesObj.full_description.trim()
            })
        });

        const company_types = this.company_types.map(companyTypesObj => {
            return ({
                value: companyTypesObj.id,
                label: companyTypesObj.code.trim()
            })
        });

        const company_status = this.company_status.map(companyStatusObj => {
            return ({
                value: companyStatusObj.id,
                label: companyStatusObj.name.trim()
            })
        });

        const contact_types = this.contact_types.map(contactTypeObj => {
            return ({
                value: contactTypeObj.id,
                label: contactTypeObj.code.trim()
            })
        });

        this.importerFileData.registerRecordHook(record => {
            let out = {}
            if (record.custom_project_id) {
                out.custom_project_id = this.formatCustomProjectId(record.custom_project_id, record.name)
            }
            if (record.proposal_delivered) {
                out.proposal_delivered = this.formatDate(record.proposal_delivered)
            }
            if (record.site_visit) {
                out.site_visit = this.formatDate(record.site_visit)
            }
            if (record.contract_amount) {
                out.contract_amount = this.formatFloatValue(record.contract_amount);
            }
            if (record.base_bid) {
                out.base_bid = this.formatFloatValue(record.base_bid);
            }
            if (record.gross_margin) {
                out.gross_margin = this.formatFloatValue(record.gross_margin);
            }
            if (record.labor_hours) {
                out.labor_hours = this.formatFloatValue(record.labor_hours);
            }
            if (record.name) {
                out.name = this.formatStringValue(record.name);
            }
            if (record.address) {
                out.address = this.formatStringValue(record.address);
            }
            if (record.city) {
                out.city = this.formatStringValue(record.city);
            }
            if (record.state) {
                out.state = {
                    value: record.state.toUpperCase()
                }
            }
            if (record.contact_name) {
                out.contact_name = this.formatStringValue(record.contact_name)
            }
            if (record.contact_email) {
                out.contact_email = this.trimSpaces(record.contact_email)
            }
            if (record.contact_phone) {
                out.contact_phone = this.formatPhoneValue(record.contact_phone)
            }
            if (record.contact_cell) {
                out.contact_cell = this.formatPhoneValue(record.contact_cell)
            }
            if (record.contact_fax) {
                out.contact_fax = this.formatPhoneValue(record.contact_fax)
            }
            if (record.pre_bid_date) {
                out.pre_bid_date = this.formatDate(record.pre_bid_date)
            }
            if (record.bid_date) {
                out.bid_date = this.formatDate(record.bid_date)
            }
            if (record.dead_date) {
                out.dead_date = this.formatDate(record.dead_date)
            }
            if (record.login_date) {
                out.login_date = this.formatDate(record.login_date)
            }
            if (record.contract_date) {
                out.contract_date = this.formatDate(record.contract_date)
            }
            if (record.proposal_delivered) {
                out.proposal_delivered = this.formatDate(record.proposal_delivered)
            }
            for (let i = 1; i <= 5; i++) {
                if (record['company_name_' + i]) {
                    out['company_name_' + i] = this.formatStringValue(record['company_name_' + i])
                }
                if (record['company_contact_name_' + i]) {
                    out['company_contact_name_' + i] = this.formatStringValue(record['company_contact_name_' + i])
                }
                if (record['company_contact_title_' + i]) {
                    out['company_contact_title_' + i] = this.formatStringValue(record['company_contact_title_' + i])
                }
                if (record['company_contact_email_' + i]) {
                    out['company_contact_email_' + i] = this.trimSpaces(record['company_contact_email_' + i])
                }
                if (record['followup_' + i]) {
                    out['followup_' + i] = this.formatDate(record['followup_' + i])
                }
                if (record['company_contact_phone_' + i]) {
                    out['company_contact_phone_' + i] = this.formatPhoneValue(record['company_contact_phone_' + i])
                }
                if (record['company_phone_' + i]) {
                    out['company_phone_' + i] = this.formatPhoneValue(record['company_phone_' + i])
                }
            }

            if (!record.address && (record.address1 && record.address2)) {
                out.address = {
                    value: record.address1 + ", " + record.address2,
                    info: [{
                        message: "Address was generated by combining address line 1 and  address line 2",
                        level: "warning"
                    }]
                }
            } else if (!record.address && (record.address1 || record.address2)) {
                // Handle the case when either address1 or address2 or both exist
                out.address = {
                    value: (record.address1 || '') + (record.address1 && record.address2 ? ', ' : '') + (record.address2 || ''),
                    info: [{
                        message: "Address was generated from address line 1 and address line 2",
                        level: "warning"
                    }]
                };
            } else if (!record.address && record.full_address) {
                let parsedAddress = parser.parseLocation(record.full_address);
                if (parsedAddress.sec_unit_type === "PO Box") {
                    out.address = {
                        value: parsedAddress.sec_unit_type + " " + parsedAddress.sec_unit_num
                    };
                } else {
                    if (parsedAddress.sec_unit_num) {
                        out.address = {
                            value: this.checkAddress(parsedAddress) + ", " + parsedAddress.sec_unit_type + " " + parsedAddress.sec_unit_num
                        };
                    } else {

                        out.address = {value: this.checkAddress(parsedAddress)};
                    }
                }
                out.city = {value: parsedAddress.city};
                out.state = {value: parsedAddress.state};
                out.zip = {value: parsedAddress.zip};
            }

            for (let j = 1; j <= 5; j++) {
                if (!record['company_contact_name_' + j] && record['company_name_' + j]) {
                    out['company_contact_name_' + j] = this.getContactNeeded(j)
                }
            }

            for (let i = 1; i <= 5; i++) {
                if (!record['company_name_' + i] &&
                    ((record['company_contact_name_' + i] && !!record['company_contact_name_' + i].trim()) ||
                        (record['company_contact_title_' + i] && !!record['company_contact_title_' + i].trim()) ||
                        (record['company_contact_title_' + i] && !!record['company_contact_email_' + i].trim()) ||
                        (record['company_contact_phone_' + i] && !!record['company_contact_phone_' + i].trim()) ||
                        (record['followup_' + i] && !!record['followup_' + i].trim()) ||
                        (record['status_' + i] && !!record['status_' + i].trim()))) {
                    out['company_name_' + i] = {
                        info: [{
                            message: "Company Name " + i + " is required",
                            level: "error"
                        }]
                    }
                }
            }

            if (this.project_sales_behaviors_name.length > 0) {
                this.project_sales_behaviors_name.forEach(item => {
                    if (record[item]) {
                        out[item] = this.formatBehaviorDate(record[item])
                    }
                })
            }

            this.fileDataCustomDateFields.map( customField => {
                if (record[customField]) {
                    out[customField] = this.formatDate(record[customField])
                }
            })

            if (record.link_to_vista && record.link_to_vista == "yes" && !record.vista_project_no) {
                out.vista_project_no = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            if (record.vista_project_no && !record.link_to_vista){
                out.link_to_vista = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }

            if (record.link_to_foundation && record.link_to_foundation == "yes" && !record.foundation_project_no) {
                out.foundation_project_no = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            if (record.foundation_project_no && !record.link_to_foundation){
                out.link_to_foundation = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }

            if (record.link_to_spectrum && record.link_to_spectrum == "yes" && !record.spectrum_project_no) {
                out.spectrum_project_no = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            if (record.spectrum_project_no && !record.link_to_spectrum){
                out.link_to_spectrum = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }

            return out
        })

        this.importerClients.registerRecordHook(record => {
            let out = {}
            if (record.name) {
                out.name = this.formatStringValue(record.name)
            }
            if (record.address) {
                out.address = this.formatStringValue(record.address)
            }
            if (record.city) {
                out.city = this.formatStringValue(record.city)
            }
            if (record.state) {
                out.state = {
                    value: record.state.toUpperCase()
                }
            }

            if (!record.address && (record.address1 && record.address2)) {
                out.address = {
                    value: record.address1 + ", " + record.address2,
                    info: [{
                        message: "Address was generated by combining address line 1 and  address line 2",
                        level: "warning"
                    }]
                }
            } else if (!record.address && (record.address1 || record.address2)) {
                // Handle the case when either address1 or address2 or both exist
                out.address = {
                    value: (record.address1 || '') + (record.address1 && record.address2 ? ', ' : '') + (record.address2 || ''),
                    info: [{
                        message: "Address was generated from address line 1 and address line 2",
                        level: "warning"
                    }]
                };
            } else if (!record.address && record.full_address) {
                let parsedAddress = parser.parseLocation(record.full_address);
                if (parsedAddress.sec_unit_type === "PO Box") {
                    out.address = {
                        value: parsedAddress.sec_unit_type + " " + parsedAddress.sec_unit_num
                    };
                } else {
                    if (parsedAddress.sec_unit_num) {
                        out.address = {
                            value: this.checkAddress(parsedAddress) + ", " + parsedAddress.sec_unit_type + " " + parsedAddress.sec_unit_num
                        };
                    } else {

                        out.address = {value: this.checkAddress(parsedAddress)};
                    }
                }
                out.city = {value: parsedAddress.city};
                out.state = {value: parsedAddress.state};
                out.zip = {value: parsedAddress.zip};
            }

            if (this.checkVistaContactFieldMapping && record.link_to_vista && record.link_to_vista == "yes" && !record['contact_name_1']) {
                out['contact_name_1'] = {
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }

            for (let i = 1; i <= 20; i++) {
                if (!record.company_name && (record['contact_name_' + i] && !!record['contact_name_' + i].trim())) {
                    out.company_name = {
                        info: [{
                            message: "Company Name is required",
                            level: "error"
                        }]
                    }
                }

                if (!record['contact_name_' + i] &&
                    ((record['contact_cell_' + i] && !!record['contact_cell_' + i].trim()) ||
                        record['contact_email_' + i] && !!record['contact_email_' + i].trim() ||
                        (record['contact_title_' + i] && !!record['contact_title_' + i].trim()))) {
                    out['contact_name_' + i] = this.getContactNeeded(i)
                }


                if(!!record['contact_name_' + i]){
                    if (!!record['contact_name_' + i].trim()) {
                        out['contact_name_' + i] = this.formatStringValue(record['contact_name_' + i])
                    }
                }
                if(!!record['contact_email_' + i]){
                    if (!!record['contact_email_' + i].trim()) {
                        out['contact_email_' + i] = this.trimSpaces(record['contact_email_' + i])
                    }
                }
                if(!!record['contact_cell_' + i]){
                    if (!!record['contact_cell_' + i].trim()) {
                        out['contact_cell_' + i] = this.formatPhoneValue(record['contact_cell_' + i])
                    }
                }
            }
            return out
        })

        this.importerContacts.registerRecordHook(record => {
            let out = {}
            if (record.name) {
                out.name = this.formatStringValue(record.name)
            }
            if (record.email) {
                out.email = this.trimSpaces(record.email)
            }
            if(record.contact_type && record.contact_type === this.contact_types.find(res=>res.is_residential === 1)?.id){
                console.log('contactType', record.contact_type);
                out.company_name = {
                    value:'Residential',
                    info: [{
                    message: "Residential name is added",
                    level: "warning"
                }]
                };
            }
            if (record.title) {
                out.title = this.formatStringValue(record.title)
            }
            if (record.followup) {
                out.followup = this.formatDate(record.followup)
            }
            // if (!record.name &&
            //     (record.cell || record.email || record.title || record.followup || record.user || record.contact_type)){
            //     out.name = this.getContactNeeded()
            // }
            if (record.cell) {
                out.cell = this.formatPhoneValue(record.cell)
            }
            if (this.contact_sales_behaviors_name.length > 0) {
                this.contact_sales_behaviors_name.forEach(item => {
                    if (record[item]) {
                        out[item] = this.formatBehaviorDate(record[item])
                    }
                })
            }
            if (record.link_to_vista && record.link_to_vista == "yes" && !record.vista_customer_no) {
                out.vista_customer_no = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            if (record.vista_customer_no && !record.link_to_vista){
                out.link_to_vista = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            if (record.link_to_foundation && record.link_to_foundation == "yes" && !record.foundation_customer_contact_no) {
                out.foundation_customer_contact_no = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            if (record.foundation_customer_contact_no && !record.link_to_foundation){
                out.link_to_foundation = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }

            if (record.link_to_spectrum && record.link_to_spectrum == "yes" && !record.spectrum_customer_no) {
                out.spectrum_customer_no = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            if (record.spectrum_customer_no && !record.link_to_spectrum){
                out.spectrum_customer_no = {
                    value: null,
                    info: [{
                        message: "Required",
                        level: "error"
                    }]
                }
            }
            return out
        })

        this.importerFileData.options.fields[(10 + this.projectDropdownsIndex)].options = sale_status;
        this.importerFileData.options.fields[(11 + this.projectDropdownsIndex)].options = marketing_status;
        this.importerFileData.options.fields[(19 + this.projectDropdownsIndex)].options = client_profile;
        this.importerFileData.options.fields[(20 + this.projectDropdownsIndex)].options = contract_type;
        this.importerFileData.options.fields[(14 + this.projectDropdownsIndex)].options = lead_from;
        this.importerFileData.options.fields[(15 + this.projectDropdownsIndex)].options = esstimator_acc_manager_take_off_person;
        this.importerFileData.options.fields[(16 + this.projectDropdownsIndex)].options = esstimator_acc_manager_take_off_person;
        this.importerFileData.options.fields[(17 + this.projectDropdownsIndex)].options = esstimator_acc_manager_take_off_person;
        this.importerFileData.options.fields[(21 + this.projectDropdownsIndex)].options = office;
        this.importerFileData.options.fields[(18 + this.projectDropdownsIndex)].options = product_service;
        this.importerFileData.options.fields[(40 + this.projectDropdownsIndex)].options = status;
        this.importerFileData.options.fields[(48 + this.projectDropdownsIndex)].options = status;
        this.importerFileData.options.fields[(56 + this.projectDropdownsIndex)].options = status;
        this.importerFileData.options.fields[(64 + this.projectDropdownsIndex)].options = status;
        this.importerFileData.options.fields[(72 + this.projectDropdownsIndex)].options = status;
        this.importerClients.options.fields[11].options = company_types;
        this.importerClients.options.fields[12].options = company_status;
        this.importerContacts.options.fields[5].options = contact_types;
        this.importerContacts.options.fields[7].options = esstimator_acc_manager_take_off_person;
        const projectFieldOptions = this.project_custom_field_options;
        const recordDetailFieldOptions = this.recordDetailCustomFieldOptions;
        const teamUsers = this.team_users;

        this.project_custom_fields.forEach((element) => {
            if (element.enabled) {
                if (element.type == 1) {
                    const options = teamUsers.filter((user) => {
                        return user
                    }).map(user => ({value: user.id, label: user.name}))
                    this.importerFileData.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    })
                } else if (element.type == 3) {
                    const options = projectFieldOptions.filter((option) => {
                        if (option.project_custom_field_id == element.id && option.enabled) {
                            return option
                        }
                    }).map(option => ({value: option.id, label: option.name}))
                    this.importerFileData.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    })
                } else if (element.type == 4) {
                    const key = element.name.trim().toLowerCase().replace(/\s/g, '_')
                    this.importerFileData.options.fields.push({
                        key: key,
                        label: element.name
                    })
                    this.fileDataCustomDateFields.push(key);
                } else {
                    this.importerFileData.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name
                    })
                }
            }
        })

        this.recordDetailCustomFields.forEach((element) => {
            if(element.enabled) {
                if(element.type == 1) {
                    const options = teamUsers.filter((user) => {
                        return user;
                    }).map(user => ({value: user.id, label: user.name}));

                    this.importerFileData.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    });
                }
                else if(element.type == 3) {
                    const options = recordDetailFieldOptions.filter((option) => {
                        if(option.record_detail_custom_field_id == element.id && option.enabled) {
                            return option;
                        }
                    }).map(option => ({value: option.id, label: option.name}));

                    this.importerFileData.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    });
                }
                else if(element.type == 4) {
                    const key = element.name.trim().toLowerCase().replace(/\s/g, '_');

                    this.importerFileData.options.fields.push({
                        key: key,
                        label: element.name
                    });

                    this.fileDataCustomDateFields.push(key);
                }
                else {
                    this.importerFileData.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name
                    });
                }
            }
        })

        this.project_sales_behaviors.forEach((behavior) => {
            const projectBehaviorName = behavior.name.trim().toLowerCase().replace(/\s/g, '_')
            this.importerFileData.options.fields.push({key: projectBehaviorName, label: behavior.name})
            this.project_sales_behaviors_name.push(projectBehaviorName);
        })

        const companyFieldOption = this.company_custom_field_options;

        this.company_custom_fields.forEach((element) => {
            if (element.enabled) {
                if (element.type == 1) {
                    const options = teamUsers.filter((user) => {
                        return user
                    }).map(user => ({value: user.id, label: user.name}))
                    this.importerClients.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    })
                } else if (element.type == 3) {
                    const options = companyFieldOption.filter((option) => {
                        if (option.company_custom_field_id == element.id && option.enabled) {
                            return option
                        }
                    }).map(option => ({value: option.id, label: option.name}))
                    this.importerClients.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    })
                } else {
                    this.importerClients.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name
                    })
                }
            }
        })

        const contactFieldOption = this.contact_custom_field_options;

        this.contact_custom_fields.forEach((element) => {
            if (element.enabled) {
                if (element.type == 1) {
                    const options = teamUsers.filter((user) => {
                        return user
                    }).map(user => ({value: user.id, label: user.name}))
                    this.importerContacts.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    })
                } else if (element.type == 3) {
                    const options = contactFieldOption.filter((option) => {
                        if (option.contact_custom_field_id == element.id && option.enabled) {
                            return option
                        }
                    }).map(option => ({value: option.id, label: option.name}))
                    this.importerContacts.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name,
                        type: "select",
                        options: options
                    })
                } else {
                    this.importerContacts.options.fields.push({
                        key: element.name.trim().toLowerCase().replace(/\s/g, '_'),
                        label: element.name
                    })
                }
            }
        })

        this.contact_sales_behaviors.forEach((contact_behavior) => {
            const behaviorName = contact_behavior.name.trim().toLowerCase().replace(/\s/g, '_');
            this.importerContacts.options.fields.push({key: behaviorName, label: contact_behavior.name})
            this.contact_sales_behaviors_name.push(behaviorName)
        })
    },
    methods: {
        getCustomProjectIdRegEx() {
            if(!this.$root.currentTeam.custom_project_id_check)
            return '';

            let state = this.$root.currentTeam.custom_project_id ? JSON.parse(this.$root.currentTeam.custom_project_id) : [];
            const customId = []; //     '^\\S+@\\S+$'
            var other = '';
            for (const element of state) {
                switch (element.id) {
                    case 'year':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                customId.push('\\d{4}');
                            } else if (element.start_from === true) {
                                let year = element.input_value;
                                let exp = '\\d{'+year.length+',}';  // '\\d{4,}'
                                customId.push(exp);
                            }
                        }
                        break;
                    case 'month':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                customId.push('\\d{2}');
                            } else if (element.start_from === true) {
                                let month = element.input_value;
                                let exp = '\\d{'+month.length+',}';  // '\\d{2,}'
                                customId.push(exp);
                            }
                        }
                        break;
                    case 'day':
                        if (element.value === true) {
                            if (element.sequential === true) {
                                customId.push('\\d{2}');
                            } else if (element.start_from === true) {
                                let day = element.input_value;
                                let exp = '\\d{'+day.length+',}';  // '\\d{2,}'
                                customId.push(exp);
                            }
                        }
                        break;
                    case 'system_generated':
                        if (element.value === true) {
                            let system_generated = element.input_value;
                            let exp = '\\d{'+system_generated.length+',}';  // '\\d{2,}'
                            customId.push(exp);
                        }
                        break;
                    case 'other':
                        if (element.value === true) {
                            if (element.seperated_by_dash === true) {
                                var other = '-';
                            } else if (element.seperated_by_space === true) {
                                var other = '/';
                            } else {
                                var other = '';
                            }
                        } else {
                            var other = '';
                        }
                        break;
                }
            }
            if (other == '-') {
                var customProjectIdRegEx = '^' + customId.join("-") + '$';
            }
            if (other == '/') {
                var customProjectIdRegEx = '^' + customId.join(" ") + '$';
            }
            if (other == '') {
                var customProjectIdRegEx = '^' + customId.join("") + '$';
            }
            return customProjectIdRegEx || '';
        },

        launchFileData(importType) {
            const $v = this;
            this.batch_id = 1;
            this.importerFileData.setCustomer({userId: this.user.id});
            this.importerFileData
                .requestDataFromUser()
                .then(function (results) {
                    $v.results = JSON.stringify(results.$data, null, 2);
                    $v.importerFileData.displaySuccess("Success!");
                    $v.createChunksFileData(results.$data, importType);
                })
                .catch(function (error) {
                    console.info(error || "window close");
                });
        },
        launchClients() {
            const $v = this;
            this.batch_id = 1;
            this.importerClients.setCustomer({userId: this.user.id});
            this.importerClients
                .requestDataFromUser()
                .then(function (results) {
                    $v.results = JSON.stringify(results.$data, null, 2);
                    $v.importerClients.displaySuccess("Success!");
                    $v.createChunksClientsData(results.$data);
                })
                .catch(function (error) {
                    console.info(error || "window close");
                });
        },
        launchContacts() {
            const $v = this;
            this.batch_id = 1;
            this.importerContacts.setCustomer({userId: this.user.id});
            this.importerContacts
                .requestDataFromUser()
                .then(function (results) {
                    $v.results = JSON.stringify(results.$data, null, 2);
                    $v.importerContacts.displaySuccess("Success!");
                    $v.createChunksContactsData(results.$data);
                })
                .catch(function (error) {
                    console.info(error || "window close");
                });
        },
        createChunksFileData(data, importType) {
            const chunkSize = 250,
                chunks = [];
            for (let i = 0; i < data.length; i += chunkSize) {
                chunks.push(data.slice(i, i + chunkSize));
            }
            const totalJobs = Math.ceil(data.length / chunkSize);
            this.saveFileData(chunks, totalJobs, chunkSize, importType);
        },
        createChunksClientsData(data) {
            const chunkSize = 250,
                chunks = [];
            for (let i = 0; i < data.length; i += chunkSize) {
                chunks.push(data.slice(i, i + chunkSize));
            }
            const totalJobs = Math.ceil(data.length / chunkSize);
            this.saveClientsData(chunks, totalJobs, chunkSize);
        },
        createChunksContactsData(data) {
            const chunkSize = 250,
                chunks = [];
            for (let i = 0; i < data.length; i += chunkSize) {
                chunks.push(data.slice(i, i + chunkSize));
            }
            const totalJobs = Math.ceil(data.length / chunkSize);
            this.saveContactsData(chunks, totalJobs, chunkSize);
        },
        saveFileData(data, totalJobs, chunkSize, importType) {
            const self = this;
            this.isLoading = true;
            if (self.currentChunkIndex <= data.length - 1) {

                axios.post('/api/file_data_import', {
                    'records': data[self.currentChunkIndex],
                    'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
                    'total_jobs_dispatched': totalJobs,
                    'batch_id': self.batch_id,
                    'data_import_id': self.data_import_id,
                    'delay': (self.currentChunkIndex + 1) * 1,
                    'importType' : importType
                })
                    .then((response) => {
                        self.batch_id = 0;
                        if (response.data.status === 'success') {
                            self.data_import_id = response.data.record_id;
                            self.fireSuccessToast((self.currentChunkIndex + 1) * chunkSize + ' Records pushed to queue for processing');
                            self.currentChunkIndex = self.currentChunkIndex + 1;
                            const importType = response.data.importType;
                            if (self.currentChunkIndex <= data.length - 1) {
                                self.saveFileData(data, totalJobs, chunkSize, importType);
                            } else {

                                self.fireSuccessToast('You records are being processed, you will be notified once the processing is done.', 7000);
                                self.isLoading = false;
                                self.currentChunkIndex = 0;
                                // axios.post('/api/clients_data_import/search-index', {
                                //     type: 'project'
                                // }).then((response) => {
                                //     self.fireSuccessToast('All Records Saved Successfully.');
                                //     self.isLoading = false;
                                //     self.currentChunkIndex = 0;
                                // }).catch((error) => {
                                //     self.fireSuccessToast('All Records Saved Successfully.');
                                //     self.isLoading = false;
                                //     self.currentChunkIndex = 0;
                                // });
                            }

                        } else {
                            self.fireErrorToast(response.data.message);
                            self.isLoading = false;
                        }
                    })
            }
        },
        saveClientsData(data, totalJobs, chunkSize) {
            const self = this;
            this.isLoading = true;

            if (self.currentChunkIndex <= data.length - 1) {

                axios.post('/api/clients_data_import', {
                    'records': data[self.currentChunkIndex],
                    'total_jobs_dispatched': totalJobs,
                    'batch_id': self.batch_id,
                    'data_import_id': self.data_import_id,
                    'delay': (self.currentChunkIndex + 1) * 1
                })
                    .then((response) => {

                        self.batch_id = 0;
                        if (response.data.status === 'success') {
                            ``
                            self.data_import_id = response.data.record_id;
                            self.fireSuccessToast((self.currentChunkIndex + 1) * chunkSize + ' Records pushed to queue for processing');
                            self.currentChunkIndex = self.currentChunkIndex + 1;

                            if (self.currentChunkIndex <= data.length - 1) {
                                self.saveClientsData(data, totalJobs, chunkSize);
                            } else {

                                self.fireSuccessToast('You records are being processed, you will be notified once the processing is done.', 7000);
                                self.isLoading = false;
                                self.currentChunkIndex = 0;

                                // axios.post('/api/clients_data_import/search-index', {
                                //     type: "companies",
                                // }).then((response) => {
                                //     self.fireSuccessToast('All Records Saved Successfully.');
                                //     self.isLoading = false;
                                //     self.currentChunkIndex = 0;
                                // }).catch((error) => {
                                //     self.fireSuccessToast('All Records Saved Successfully.');
                                //     self.isLoading = false;
                                //     self.currentChunkIndex = 0;
                                // });
                            }

                        } else {
                            self.fireErrorToast(response.data.message);
                            self.isLoading = false;
                        }
                    })
            }
        },
        saveContactsData(data, totalJobs, chunkSize) {
            const self = this;
            this.isLoading = true;

            if (self.currentChunkIndex <= data.length - 1) {

                axios.post('/api/contacts_data_import', {
                    'records': data[self.currentChunkIndex],
                    'total_jobs_dispatched': totalJobs,
                    'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
                    'batch_id': self.batch_id,
                    'data_import_id': self.data_import_id,
                    'delay': (self.currentChunkIndex + 1) * 1
                })
                    .then((response) => {

                        self.batch_id = 0;
                        if (response.data.status === 'success') {
                            ``
                            self.data_import_id = response.data.record_id;
                            self.fireSuccessToast((self.currentChunkIndex + 1) * chunkSize + ' Records pushed to queue for processing');
                            self.currentChunkIndex = self.currentChunkIndex + 1;

                            if (self.currentChunkIndex <= data.length - 1) {
                                self.saveContactsData(data, totalJobs, chunkSize);
                            } else {
                                self.fireSuccessToast('You records are being processed, you will be notified once the processing is done.', 7000);
                                self.isLoading = false;
                                self.currentChunkIndex = 0;

                                // axios.post('/api/contacts_data_import/search-index', {
                                //     type: "contacts",
                                // }).then((response) => {
                                //     self.fireSuccessToast('All Records Saved Successfully.');
                                //     self.isLoading = false;
                                //     self.currentChunkIndex = 0;
                                // }).catch((error) => {
                                //     self.fireSuccessToast('All Records Saved Successfully.');
                                //     self.isLoading = false;
                                //     self.currentChunkIndex = 0;
                                // });
                            }

                        } else {
                            self.fireErrorToast(response.data.message);
                            self.isLoading = false;
                        }
                    })
            }
        },
        fireSuccessToast(message, timer = 4000) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: timer
            });

            Toast.fire({
                type: 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Toast.fire({
                type: 'error',
                title: message,
            });
        },
        formatStringValue(value) {
            if (!!value.trim()) {
                return {
                    value: value.trim()
                        .replace(/(\s-)+/g, '-').replace(/(-\s)+/g, '-').replace(/-/g, ' - ')
                        .replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase())
                }
            }else{
                return {
                    value:''
                };

            }
        },
        formatFloatValue(value) {
            value = parseFloat(value.replace(/[\$,]/g, "")).toFixed(2)
            if(!isNaN(value)) {
                return {
                    value: parseFloat(value.replace(/[\$,]/g, "")).toFixed(2),
                    info: [{
                        message: "Formatted value to 2 decimals",
                        level: "warning"
                    }]
                }
            }else{
                return {
                    value: value,
                    info: [{
                        message: "Invalid number value",
                        level: "error"
                    }]
                }
            }

        },
        formatPhoneValue(value) {
            return {
                value: value.replace(/\D/gi, ''),
                info: [{
                    message: "Phone number formatted",
                    level: "warning"
                }]
            }
        },
        formatDate(value) {
            value = value.replace(/\s[AP]M$/, '');
            const isValidFormat = this.checkDateFormats(value);

            if (isValidFormat && moment.utc(value).isValid()) {
                return {
                    value: moment.utc(value).format('M/D/yyyy'),
                    info: [{
                        message: "Dates reformatted",
                        level: "warning"
                    }]
                }
            }else{
                return {
                    value: value,
                    info: [{
                        message: "Date is invalid (Supported Formats are M/D/yyyy, MM/DD/yyyy, M/D/yyyy hh:mm:ss, MM/DD/yyyy hh:mm:ss, M-D-yyyy, MM-DD-yyyy, M-D-yyyy hh:mm:ss, MM-DD-yyyy hh:mm:ss, MM-DD-yyyy hh:mm)",
                        level: "error"
                    }]
                }
            }

        },
        formatBehaviorDate(value) {

            const isValidFormat = this.checkDateFormats(value, true);
            value = value.replace(/\s[AP]M$/, '');
            if (isValidFormat && moment.utc(value).isValid()) {
                return {
                    value: moment.utc(value).format('M/D/yyyy hh:mm A'),
                    info: [{
                        message: "Dates reformatted",
                        level: "warning"
                    }]
                }
            }else{
                return {
                    info:[{
                        message: "Date is invalid (Supported Formats are M/D/yyyy, MM/DD/yyyy, M/D/yyyy hh:mm:ss, MM/DD/yyyy hh:mm:ss, M-D-yyyy, MM-DD-yyyy, M-D-yyyy hh:mm:ss, MM-DD-yyyy hh:mm:ss, MM-DD-yyyy hh:mm A)",
                        level: "error",
                    }]
                }
            }
        },
        trimSpaces(value) {
            return {
                value: value.trim().toLowerCase().replace(/,\s*$/, ""),
                info: [{
                    message: "Spaces removed",
                    level: "warning"
                }]
            }
        },
        formatCustomProjectId(value, name) {
            const matchedProject = this.team_custom_project_ids.find(project => project.id === value);
            if (matchedProject && this.formatStringValue(name).value !== matchedProject.name) {
                return {
                    info: [{
                        message: "A project with this project custom ID already exists, but the names don't match. Enter another ID and try again.",
                        level: "error",
                    }]
                };
            }

            if(this.customProjectIdRegExp && !value.match(this.customProjectIdRegExp)){
                return {
                    info:[{
                        message: "Project custom ID needs to match format set in the settings",
                        level: "error",
                    }]
                }
            }

            return value;

        },

        getContactNeeded(index = null) {
            if (index) {
                return {
                    value: "Contact Needed " + index,
                    info: [{
                        message: "Contact Needed " + index,
                        level: "warning"
                    }]
                }
            } else {
                return {
                    value: "Contact Needed",
                    info: [{
                        message: "Contact Needed",
                        level: "warning"
                    }]
                }
            }
        },

        checkAddress(address) {
            const prefix = address.prefix || "";
            const number = address.number || "";
            const street = address.street || "";
            const type = address.type || "";
            const suffix = address.suffix || "";
            let outAddress =
                prefix + " " + number + " " + street + " " + type + " " + suffix;
            let addressArray = outAddress.split("");
            if (addressArray[addressArray.length - 1] === " ") {
                addressArray.pop();
            }
            if (addressArray[0] === " ") {
                addressArray.shift();
            }
            outAddress = addressArray.join("");
            return outAddress;
        },
        checkDateFormats(value, isBehaviorDate = false) {
            const dateReFormats = [
                /^\d{1,2}\/\d{1,2}\/\d{2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{2} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{2} \d{1,2}:\d{1,2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{2} \d{1,2}:\d{1,2} ?[AP]M$/,
                /^\d{1,2}-\d{1,2}-\d{2}$/,
                /^\d{1,2}-\d{1,2}-\d{2} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{2} \d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{2} \d{1,2}:\d{1,2} ?[AP]M$/
            ];

            const needToReformat = dateReFormats.some(regex => regex.test(value));
            if (needToReformat) {
                let lastPart = '';
                if (isBehaviorDate) {
                    if (value.includes('AM')) {
                        lastPart = ' AM';
                    } else if (value.includes('PM')) {
                        lastPart = ' PM';
                    }
                    value = value.replace(/\s[AP]M$/, '');
                }
                const parts = value.split(/[\/-]/);
                const currentYear = new Date().getFullYear().toString().substring(0, 2);
                parts[2] = currentYear + parts[2];
                value = parts.join('/');
                if (isBehaviorDate) {
                    value = value + lastPart;
                }
            }

            const dateFormats = [
                /^\d{1,2}\/\d{1,2}\/\d{4}$/,
                /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{4}$/,
                /^\d{1,2}-\d{1,2}-\d{4} \d{1,2}:\d{1,2}:\d{1,2}$/,
                /^\d{1,2}-\d{1,2}-\d{4} \d{1,2}:\d{1,2}$/
            ];

            if (isBehaviorDate) {
                dateFormats.push(/^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{1,2} ?[AP]M$/);
                dateFormats.push(/^\d{1,2}-\d{1,2}-\d{4} \d{1,2}:\d{1,2} ?[AP]M$/);
            }

            return dateFormats.some(regex => regex.test(value));
        }

},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#raw_output {
    width: 100%;
    padding: 64px;
    margin: 32px 0;
    border: 1px solid #c1c6d1;
    border-radius: 4px;
    font-family: "Courier New", monospace;
    background-color: #3c4151;
    color: #fff;
    height: 200px;
}

</style>
<style>
.flatfile-active .swal2-container {
    z-index: 999999 !important;
}
.active-stage .sc-pNWxx::after{
    content: "(Note: If linking to Vista customers, make sure the Vista Customer number mentioned is accurate to avoid mismatching of customers between Followup & Vista)";
    font-size: 14px !important;
    color: rgb(102, 125, 141);
    margin-left: 5px !important;

}
</style>
